import { authFetch } from '../services/authFetch';
import { formatViewData } from '../utilities/views';

export function getMenuItems({ setViewError, setViews, handleLogOut, setAddress }) {
  authFetch(`${window.AnalyticsPortalConfig.apiAddress}/MenuItems`)
    .then((result) => {
      if (!result.ok) {
        if (result.status === 401) {
          throw new Error("401");
        }

        throw new Error("Response not OK.");
      }

      return result.json();
    })
    .then((result) => {
      const newViews = formatViewData(result.views);

      if (Object.keys(newViews).length === 0) {
        setViewError("No Views Found");
      } else {
        setViews(newViews);
      }
      setAddress({
        rapid: result.rapidAddress,
        SLIP: result.slipAddress,
        learningCenter: result.learningCenterAddress,
        slacalWebsite: result.slacalWebsiteAddress,
     });
    })
    .catch((error) => {
      if (error.message === "401") {
        handleLogOut();

        return;
      }

      console.error(error);

      setViewError("Error Loading Views");
    });
}
